// material-ui
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

// project imports
import ContainerWrapper from 'components/ContainerWrapper';

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

export default function AuthFooter() {
  return (
    <ContainerWrapper>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        sx={{ gap: 2, justifyContent: { xs: 'center', sm: 'space-between' }, textAlign: { xs: 'center', sm: 'inherit' }, py: 2 }}
      >
        <Typography variant="subtitle2" sx={{ color: 'secondary.main' }}>
          &copy; {new Date().getFullYear()} NextGen GTN&trade;. All rights reserved.
        </Typography>
        <Typography variant="subtitle2" sx={{ color: 'secondary.main' }}>
          Developed by{' '}
          <Link
            href="https://binarymindtechnologies.com/"
            target="_blank"
            rel="noopener"
            underline="hover"
            sx={{ color: 'primary.main', fontWeight: 600 }}
          >
            BinaryMind Technologies
          </Link>
        </Typography>
      </Stack>
    </ContainerWrapper>
  );
}
